module.exports = __webpack_public_path__ + "static/media/pest_target.96025608.pdf";